import { render, staticRenderFns } from "./CgrnIndex.vue?vue&type=template&id=2dba9182"
import script from "./CgrnIndex.vue?vue&type=script&lang=js"
export * from "./CgrnIndex.vue?vue&type=script&lang=js"
import style0 from "./CgrnIndex.vue?vue&type=style&index=0&id=2dba9182&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports